import React from 'react';
import styled from 'styled-components';
import Group, { GroupProps } from './group';

// for accessibility reasons - wrapping each tag in a li
const TagGroup = styled(({ children, ...rest }: GroupProps) => (
  <Group as={'ul'} bottomItemMargin={'xs'} flexWrap={'wrap'} {...rest}>
    {React.Children.map(children, child => (child ? <li>{child}</li> : null))}
  </Group>
))`
  & {
    list-style: none;
  }
`;

export default TagGroup;
